import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { PlusCircle, Trash2, MessageSquare } from 'lucide-react';
import { useIAChat } from '../../contexts/IAChatContext.jsx';

moment.locale('es');

/**
 * Lista de conversaciones previas del usuario — puerto Tailwind de
 * `IbuFront/src/components/ia/ConversationList.jsx` (V1). Solo lectura/borrar: el
 * backend (`ConversacionService.listar/obtener/eliminar`) ya filtra por
 * `req.userId`, así que esta lista nunca puede mostrar/borrar conversaciones de otro
 * usuario aunque el frontend fallara al filtrar.
 */
export default function ConversationList({ onAfterSelect, onAfterNew }) {
  const { conversaciones, activeId, seleccionarConversacion, nuevaConversacion, eliminarConversacion } = useIAChat();
  const ordenadas = [...conversaciones].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <div className="flex flex-col h-full">
      <div className="p-2 border-b border-slate-200 flex-shrink-0">
        <button
          type="button"
          onClick={() => {
            nuevaConversacion();
            onAfterNew && onAfterNew();
          }}
          className="btn-outline w-full text-sm px-2 py-1.5"
        >
          <PlusCircle size={16} /> Nuevo chat
        </button>
      </div>

      <div className="flex-grow overflow-auto">
        {ordenadas.length === 0 && <p className="text-slate-400 text-sm text-center mt-4 px-3">Aún no tienes conversaciones.</p>}
        {ordenadas.map((c) => (
          <div
            key={c._id}
            onClick={() => {
              seleccionarConversacion(c._id);
              onAfterSelect && onAfterSelect();
            }}
            className={`flex items-center px-3 py-2 cursor-pointer border-l-2 ${
              c._id === activeId ? 'border-primary-600 bg-primary-50' : 'border-transparent hover:bg-slate-50'
            }`}
          >
            <MessageSquare size={16} className="text-slate-400 mr-2 flex-shrink-0" />
            <div className="flex-grow min-w-0">
              <div className="text-sm truncate text-slate-700">{c.titulo}</div>
              <div className="text-slate-400" style={{ fontSize: 11 }}>
                {moment(c.updatedAt).fromNow()}
              </div>
            </div>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                eliminarConversacion(c._id);
              }}
              title="Eliminar conversación"
              className="p-1.5 rounded-md ml-2 flex-shrink-0 text-slate-400 hover:text-danger-500 hover:bg-slate-100"
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
